import { DateTime } from 'luxon';

/** Formats a form Date as the `HH:mm` string the edge expects. */
export const toTimeOfDay = (value: Date): string => DateTime.fromJSDate(value).toFormat('HH:mm');

/** The tab row forms hold minutes; the stored brand holds HH:MM:SS durations. */
export const toMinutes = (value: string | number | undefined): number => {
  if (typeof value === 'string' && value.includes(':')) {
    const [hours, minutes] = value.split(':').map(Number);
    return hours * 60 + minutes;
  }
  return Number(value);
};
